import type { RunAttemptResponse, StartDetectionRunRequest } from '@prerender/diagnostics-api';

import api from '../../api/apiSlice';

export const runsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    startDetectionRun: builder.mutation<RunAttemptResponse, StartDetectionRunRequest>({
      query: (request) => ({ url: '/diagnostics/runs', method: 'POST', body: request }),
    }),
    getRunAttempt: builder.query<RunAttemptResponse, string>({
      query: (reference) => `/diagnostics/runs/${encodeURIComponent(reference)}`,
    }),
    getLatestRunAttempt: builder.query<RunAttemptResponse, void>({
      query: () => '/diagnostics/runs/latest',
    }),
  }),
});

export const { useStartDetectionRunMutation, useGetRunAttemptQuery, useGetLatestRunAttemptQuery } = runsApi;
